import { AppName } from '@shared/types'
import { configureAxios } from '@ui-common/utils/network'
import axios from 'axios'

const env = import.meta.env

configureAxios(axios, env, AppName.DigiLa)
